import type { Patient, UbaPatient } from './queries'

import { z } from 'zod'

export interface UbaProduct {
  categoryID: number
  channelName: string
  comparableNDC: string
  countryOrigin: string
  dinNumber: string
  dosageForm: string
  foreignTradeName: string
  genericName: string
  hiC3Code: string
  manufacturer: string
  minimumOrderQty: number
  packSize: string
  packSizeUnit: string
  price: string
  priceperunit: string
  primaryProductAttributeName: string
  proSalesChannelId: number
  productAttributes: string
  productCategories: string
  productDescription: string
  productID: number
  productName: string
  secondaryProductAttributesName: string
  stock: string
  strength: string
  strengthUnit: string
  unitType: string
  usTradeName: string
}

export interface UbaOrderProduct {
  productId: number
  productName: string
  manufacturer: string
  price: string
  quantity: number
  dinNumber: string
}

export const placeOrderSchema = z.object({
  patientId: z.string(),
  patientGUID: z.string(),
  shippingId: z.number(),
  products: z.array(z.object({
    productId: z.number(),
    productName: z.string(),
    manufacturer: z.string(),
    price: z.string(),
    quantity: z.number(),
    dinNumber: z.string().nullish()
  })),
  shippingQuantity: z.number(),
  counselling: z.number(),
  orderComment: z.string(),
  couponCode: z.string(),
  orderDate: z.string(),
  addRemoteDataLogger: z.boolean().optional()
})

const placeOrderWithAttachments = placeOrderSchema.and(z.object({ files: z.array(z.instanceof(File)) }))

export type UbaPlaceOrder = z.infer<typeof placeOrderWithAttachments>

export type UbaOrder = any

export interface GetOrderProduct {
  id: string
  uba_order: string
  product_id: string
  product_name: string
  price: number
  quantity: number
  din: string
}

export interface GetOrderResponse {
  id: string
  order_number: string
  order_date: string
  status: string
  total: number
  comment?: string
  shipping_address: string
  shipping_country: string
  shipping_state: string
  shipping_city: string
  shipping_price: string
  shipping_description: string
  counseling?: string
  add_remote_data_logger?: boolean
  attachments?: Array<{ id: string, mimeType: string, fileName: string }>
  tracking: {
    'data': Array<{ 'orderNumber': string, 'trackingLink': string, 'trackingNumber': string }>
  }
  products: GetOrderProduct[]
}

// todo - use common type (or move this to globals)
export interface SelectOption {
  label: string
  value: number | string
}

export interface Product {
  id: string
  uba_order: string
  product_id: string
  product_name: string
  price: number
  quantity: number
}

export interface Order {
  id: string
  order_number: string
  order_date: string
  status: string
  total: number
  products: Product[]
}

export const counsellingOptions = [
  { value: 1, label: 'Please have an UBACARE pharmacist reach out to discuss my medication' },
  { value: 0, label: 'I do not need to speak with the pharmacist at this time' }
]

export interface PatientData {
  ubaUser: boolean
  data: Patient
}

export interface UbaPatientData {
  ubaUser: boolean
  data: UbaPatient
}
